<template>
  <BaseLayout>
    <div
      class="md:flex-row relative backgroundImage py-6 md:p-0 flex flex-col justify-center min-h-screen"
    >
      <div
        class="md:w-5/12 w-11/12 bg-white opacity md:opacity-100 rounded-md md:rounded-sm xl:h-screen xl:flex xl:flex-col p-5 sm:p-10 mx-auto"
      >
        <div class="mb-8 mt-4 max-w-sm mx-auto w-full">
          <router-link :to="{ name: 'DashboardBeforeLogin' }">
            <img
              :src="require(`@/assets/img/fitclas.png`)"
              alt=""
              class="w-32 object-cover"
            />
          </router-link>
        </div>
        <div class="h-full flex items-center">
          <div class="max-w-sm mx-auto flex-1">
            <h3 class="text-3xl font-semibold leading-8">Sign in to your <br>account</h3>
              <!-- Don't have one yet? -->
            <form class="mt-2 max-w-sm" @submit.prevent="handleLogin">
              <div class="">
                <FormInput
                  :type="'text'"
                  v-model="$v.email.$model"
                  :classStr="{ 'border-red-700': $v.email.$error }"
                  >Email</FormInput
                >
                <div v-if="$v.email.$error">
                  <small class="text-red-700" v-if="!$v.email.required">
                    Email field is required.
                  </small>
                  <small class="text-red-700" v-if="!$v.email.email">
                    Accepts valid email addresses.
                  </small>
                </div>
              </div>

              <div class="mt-4">
                <FormInput
                  :type="'password'"
                  v-model="$v.password.$model"
                  :classStr="{ 'border-red-700': $v.password.$error }"
                  >Password</FormInput
                >
                <div v-if="$v.password.$error">
                  <small class="text-red-700" v-if="!$v.password.required">
                    Password field is required.
                  </small>
                </div>
                <div class="flex mt-4 items-center justify-between">
                  <div class="flex items-center">
                    <input type="checkbox" class="h-6 w-6" v-model="rememberFlag"/>
                    <span class="ml-1 font-semibold text-xs">Remember me</span>
                  </div>
                  <small class="text-sm text-green-light font-semibold">
                    <router-link
                      :to="{ name: 'ResetPassword' }"
                      class="text-xs hover:underline"
                    >
                      Forgot password?
                    </router-link>
                  </small>
                </div>
              </div>
              <div class="mt-8 mb-3">
                <Button>Login</Button>
              </div>
              <GoogleLogin @onLogin="onGoogleLogin" />

              <div class="mt-4 font-semibold text-xs">
                Not registered yet?
                <router-link
                  :to="{ name: 'CompleteSignup' }"
                  class="text-green-light font-semibold hover:underline"
                >
                  Create an Account
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        class="min-h-screen hidden md:inline md:w-7/12"
        :class="LOADING ? 'bg-gray-medium' : 'bg-white'"
      >
        <img
          class="object-cover md:object-cover h-screen w-full"
          :src="require(`@/assets/img/login.webp`)"
          alt="..."
          @load="imgLoadHandler"
          v-show="!LOADING"
        />
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from "@/components/layouts/BaseLayout";
import GoogleLogin from "@/components/google-login/GoogleLogin";
import { FormInput, Button } from "@/components/t-components";
import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import firebase from "firebase/app";
import * as Cookies from 'js-cookie'
import "firebase/messaging";

export default {
  name: "Login",
  components: {
    BaseLayout,
    Button,
    GoogleLogin,
    FormInput,
  },
  data() {
    return {
      email: null,
      password: null,
      firebase_token: null,
      LOADING: true,
      rememberFlag: false,
      decryptedUsername: null
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  methods: {
    ...mapActions(["login"]),

    imgLoadHandler() {
      this.LOADING = false;
    },

    onGoogleLogin(user) {
      this.$store.commit('setAuthStatus', true)
      if (user && user.user_type == this.TRAINER) {
        this.$router.push({ name: "dashboard" });
      } else {
        this.$router.push({ name: "Newhome" });
      }
    },

    handleLogin() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        const data = {
          email: this.email,
          password: this.password,
          firebase_token: this.firebase_token,
        };
        this.login(data).then(() => {
          this.rememberFlagHandler()
          let redirect = this.$route.query.redirect || ''
          if (this.getUser() && this.getUser().user_type == this.TRAINER) {
            redirect && redirect.length ? this.$router.push(redirect) : this.$router.push({ name: "dashboard" })
          } else if (this.getUser() && this.getUser().user_type == this.USER) {
            redirect && redirect.length ? this.$router.push(redirect)  : this.$router.push({ name: "Newhome" });
          } else if (this.getUser() && this.getUser().user_type == this.ADMIN) {
            this.$router.push({ name: "AdminDashboard" });
          } else {
            this.$router.push({ name: "DashboardBeforeLogin" });
          }
        });
      }
    },
    async rememberFlagHandler () {
      const remFlag = Cookies.get('fitclass_remFlag')
      if (this.rememberFlag && (!remFlag || (remFlag && this.decryptedUsername !== this.email))) {
        // Define the key for AES encryption
        const key = window.config.VUE_APP_PUSHER_APP_KEY
        //importing crpto module
        let CryptoJS = await import('crypto-js')
        // Encrypt the values using AES encryption
        const encryptedUsername = CryptoJS.AES.encrypt(this.email, key).toString()
        const encryptedPassword = CryptoJS.AES.encrypt(this.password, key).toString()
        // Combine the encrypted values into a single string
        const cookieValue = `${encryptedUsername}|${encryptedPassword}`
        // Set the cookie with the combined string as the value and the expiration time 
        const expirationDate = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000) // Expires in 30 days
        Cookies.set('fitclass_remFlag', cookieValue, {
          expires: expirationDate,
          secure: true
        })
      }
    },
    async cookieCheckDecryptor () {
      const remFlag = Cookies.get('fitclass_remFlag')
      if (remFlag && remFlag.length) {
        const cookieParts = remFlag.split('|'); // Split the cookie value into two parts
        const encryptedUsername = cookieParts[0];
        const encryptedPassword = cookieParts[1];
        const key = window.config.VUE_APP_PUSHER_APP_KEY;
        let CryptoJS = await import('crypto-js');
        // Decrypt the values using AES decryption
        this.decryptedUsername = CryptoJS.AES.decrypt(encryptedUsername, key).toString(CryptoJS.enc.Utf8);
        const decryptedPassword = CryptoJS.AES.decrypt(encryptedPassword, key).toString(CryptoJS.enc.Utf8);
        this.email = this.decryptedUsername
        this.password = decryptedPassword
        this.rememberFlag = true
      }
    }
  },
  created() {
    this.handleNotificationPermission();
    this.cookieCheckDecryptor();
    if (firebase.messaging.isSupported()) {
      firebase.app();
      var messaging = firebase.messaging();

      messaging
        .requestPermission()
        .then(() => messaging.getToken())
        .then((token) => {
          this.firebase_token = token;
        })
        .catch(function (e) {
          console.log("Unable to get permission to notify.");
        });
    }
    // this.verifyLoggedIn();
  },
  watch: {
    email () {
      this.email = this.email && this.email.trim()
    }
  }
};
</script>

<style scoped>
@media only screen and (max-width: 767px) {
  .backgroundImage {
    background-image: url("../assets/img/login.webp");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .opacity {
    opacity: 0.9;
  }
}
input[type="checkbox"] {
  accent-color: #99c355;
}
</style>